/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AgencyResponse
 */
export interface AgencyResponse {
    /**
     * 
     * @type {string}
     * @memberof AgencyResponse
     */
    agencyId?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyResponse
     */
    abtaNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyResponse
     */
    agencyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyResponse
     */
    agencyGroup?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgencyResponse
     */
    brand?: number;
    /**
     * 
     * @type {string}
     * @memberof AgencyResponse
     */
    market?: string | null;
}

export function AgencyResponseFromJSON(json: any): AgencyResponse {
    return AgencyResponseFromJSONTyped(json, false);
}

export function AgencyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agencyId': !exists(json, 'agencyId') ? undefined : json['agencyId'],
        'abtaNumber': !exists(json, 'abtaNumber') ? undefined : json['abtaNumber'],
        'agencyName': !exists(json, 'agencyName') ? undefined : json['agencyName'],
        'agencyGroup': !exists(json, 'agencyGroup') ? undefined : json['agencyGroup'],
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
        'market': !exists(json, 'market') ? undefined : json['market'],
    };
}

export function AgencyResponseToJSON(value?: AgencyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agencyId': value.agencyId,
        'abtaNumber': value.abtaNumber,
        'agencyName': value.agencyName,
        'agencyGroup': value.agencyGroup,
        'brand': value.brand,
        'market': value.market,
    };
}


